export default {
  ABOUT: "about",
  CAREERS: "careers",
  DOCUMENT: {
    BASE: "document",
    INDEX: "document.index",
  },
  EVENT: {
    BASE: "event",
    INDEX: "event.index",
    SHOW: "event.show",
  },
  FUNDING: "funding",
  HOME: "home",
  INNOVATION: "innovation",
  NEWS: {
    BASE: "news",
    INDEX: "news.index",
    SHOW: "news.show",
  },
  NOT_FOUND: "not_found",
  POLICIES: "policies",
  POST: {
    BASE: "post",
    INDEX: "post.index",
  },
  PROJECTS: "projects",
  TEAM: "team",
};
